export const SET_EDIT_COMPANY_DATA = 'SET_EDIT_COMPANY_DATA';

export function setEditCompanyData(company) {
  return {
    type: SET_EDIT_COMPANY_DATA,
    company,
  };
}
